export const getCorpNameFromPayments = (payments = [] ) => {
    const payment = payments.find( payment => {
        const isLOC = payment.entitlementType === 'CORPORATE_LINE_OF_CREDIT';
        const hasCorpName =  payment.metadata && !!payment.metadata['cORPNAME']
        
        return isLOC && hasCorpName;
    })

    if(payment){
        // the order response is transformed by humps.camelizeKeys
        // which does not handle all uppercase object property names well by default
        // metadata is a dictionary structure which looks like
        // {"metadata": {"CORP_NAME": "Dunder Mifflin" }} and gets transformed to
        //  {"metadata": {"cORPNAME": "Dunder Mifflin" }} by humps
        return payment.metadata['cORPNAME'];
    }
}



// WEBPACK FOOTER //
// ./client/app/components/home/taxExemptHelpers.js